<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
::v-deep .el-drawer__header:focus-within,
::v-deep .el-drawer__header *:focus {
  outline: none !important;
}
</style>

<style lang="scss">
.el-table--border th.gutter:last-of-type {
  display: block !important;
  width: 17px !important;
}
</style>
